import styled from '@emotion/styled';
import { IAirport } from '../../../../../contentful/types/IAirport';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';

interface IFlightCellProps {
	airport: string;
	airportDetails?: IAirport;
	city: string;
	codeShareFlightNumber: string;
}

export function FlightCell({
	airportDetails,
	airport,
	city,
	codeShareFlightNumber,
}: IFlightCellProps) {
	const airportCode = airportDetails ? airportDetails.iata : airport;
	return (
		<StyledFlightCell>
			<AirportCode>{airportCode}</AirportCode>
			<AirportCity>
				{
					city // city comes from old API
					// TODO: when the new API is setup this information should come from aiportDetails.city
				}
				<AirportCodeText> ({airportCode})</AirportCodeText>
			</AirportCity>
			<CodeShareFlightNumber>{codeShareFlightNumber}</CodeShareFlightNumber>
		</StyledFlightCell>
	);
}

const StyledFlightCell = styled.div`
	display: flex;
	gap: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		gap: ${Css.pxToRem(4)};
	}
`;

const AirportCode = styled.div`
	background-color: ${Color.BodyBackground};
	padding: 0 ${Css.pxToRem(2)};
	height: ${Css.pxToRem(24)};
	width: ${Css.pxToRem(46)};
	min-width: ${Css.pxToRem(46)};
	border-radius: ${Css.pxToRem(25)};
	text-align: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

const AirportCodeText = styled.div`
	display: none;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: inline;
	}
`;

const AirportCity = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;

	font-weight: 700;
`;

const CodeShareFlightNumber = styled.div`
	color: ${Color.Neutral};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(14)};
		line-height: ${Css.pxToRem(20)};
		color: ${Color.OnBackgroundText2};
	}
`;
